/* eslint-disable max-len */
import 'plyr-react/plyr.css';

import cn from 'classnames';
import Hls from 'hls.js';
import Plyr, { APITypes, PlyrProps } from 'plyr-react';
import {
  memo, useEffect, useRef, useState,
} from 'react';

import { convertStoMs } from '../../utils/convert-st-to-ms';
import Chip from '../Chip';
import PlayIcon from '../SVGIcons/PlayIcon';
import classes from './video-block.module.scss';
import { VideoBlockProps } from './VideoBlock.type';

function VideoBlock({
  videoLink,
  videoBlockShow,
  videoBlockTitle,
  videoDescription,
  videoTag,
}: VideoBlockProps) {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [videoDuration, setVideoDuration] = useState(0);

  const videoRef = useRef<APITypes | null>(null);

  useEffect(() => {
    const video = document.getElementById('plyr') as HTMLVideoElement;

    const onVideoLoaded = () => {
      if (
        video
        && video.duration
        && video.duration !== Infinity
        && video.duration > 0
      ) {
        setVideoDuration(video.duration);
      }
    };

    if (video) {
      video.addEventListener('loadeddata', onVideoLoaded);
    }

    return () => {
      if (video) {
        video.removeEventListener('loadeddata', onVideoLoaded);
      }
    };
  });

  return videoBlockShow && videoLink ? (
    <div className={classes.videoWrapper}>
      <div className={classes.videoContainer}>
        <Plyr
          id="plyr"
          ref={(player) => {
            videoRef.current = player;
            const video = document.getElementById('plyr') as HTMLVideoElement;

            const videoSrc = videoLink || '';
            if (Hls.isSupported() && player?.plyr.on) {
              const hls = new Hls();
              hls.loadSource(videoSrc);
              hls.attachMedia(video);
              /* eslint-disable @typescript-eslint/ban-ts-comment */
              // @ts-ignore
              videoRef.current!.plyr.media = video;
            } else if (
              video.canPlayType('application/vnd.apple.mpegurl')
              && player?.plyr.play
            ) {
              video.src = videoSrc;
              // @ts-ignore
              videoRef.current!.plyr.media = video;
              videoRef.current!.plyr.muted = true;
              // @ts-ignore
              videoRef.current!.plyr.media.playsInline = true;
            }
          }}
          options={{
            loop: {
              active: true,
            },
            fullscreen: {
              enabled: false,
            },
            autoplay: false,
            muted: false,

            // @ts-ignore
            controls: isVideoPlaying
              ? [
                'play',
                'progress',
                'current-time',
                'duration',
                'mute',
                'volume',
                'fullscreen',
              ]
              : [],
          }}
          source={{} as PlyrProps['source']}
        />
        <div
          className={cn({
            [classes.videoOverlay]: true,
            [classes.hidden]: isVideoPlaying,
          })}
        >
          <div>
            {videoTag
            && (
            <div className={classes.chip}>
              <Chip
                textColor="black"
                title={videoTag}
                color="#FFF"
              />
            </div>
            )}

            <div className={classes.videoHeader}>
              <p>{videoDescription}</p>
              <h3>{videoBlockTitle}</h3>
            </div>

            <div className={classes.videoDuration}>
              0:00 /
              {' '}
              {convertStoMs(videoDuration)}
            </div>
            <div
              role="none"
              onClick={() => {
                if (videoRef.current!.plyr) {
                  setTimeout(() => videoRef.current!.plyr.play(), 1);
                  setIsVideoPlaying(true);
                }
              }}
              className={cn({
                [classes.playButton]: true,
              })}
            >
              <PlayIcon fill="black" />
              {' '}
              Смотреть
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

export default memo(VideoBlock);
